export default __webpack_public_path__ + "static/repairBlock1-0b7075985bd2f1d66bed59be4322f7a4.png";